export const clearAnonymization = (text: string) => text.replace(/\*/g, '');
